import { useContext } from 'react';
import { useQueryClient } from 'react-query';
import { LanguageContext } from '../contexts/LanguageContext';

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  const queryClient = useQueryClient();

  if (context === undefined) {
    throw new Error('useLanguage должен использоваться внутри LanguageProvider');
  }

  const setLanguageWithCache = (lang: 'en' | 'ru' | 'hy') => {
    context.setLanguage(lang);
    // Инвалидируем все запросы к API
    queryClient.invalidateQueries();
  };

  const formatDuration = (minutes: number | null): string => {
    if (!minutes) return '';
    if (minutes < 60) return `${minutes} ${context.t('common.minutes')}`;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if (remainingMinutes === 0) return `${hours} ${context.t('common.hours')}`;
    return `${hours} ${context.t('common.hours')} ${remainingMinutes} ${context.t('common.minutes')}`;
  };

  return {
    ...context,
    setLanguage: setLanguageWithCache,
    formatDuration,
  };
};